// extracted by mini-css-extract-plugin
export var blockedMessage = "_bk-3";
export var blockedOverlay = "_bk-1";
export var fadeIn = "_bk-2";
export var hereLink = "_bk-0";
export var slideUp = "_bk-4";